import axios, { AxiosInstance, AxiosError } from 'axios';
import { getLoginRedirectPath } from '@/lib/browserE2eAuth';

// Пустой baseURL — запросы вида /api/... идут на origin, CRA setupProxy снимает /api.
// Абсолютный REACT_APP_API_URL — корень Nest; префикс /api в url убирается в interceptor ниже.
const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

class ApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    this.api.interceptors.request.use(
      (config) => {
        if (API_URL && typeof config.url === 'string' && config.url.startsWith('/api/')) {
          config.url = config.url.replace(/^\/api/, '') || '/';
        }
        const token = localStorage.getItem('accessToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    this.api.interceptors.response.use(
      (response) => {
        const data = response.data;
        if (data && typeof data === 'object' && 'data' in data && 'timestamp' in data) {
          return data.data;
        }
        return data;
      },
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('accessToken');
          const path = getLoginRedirectPath(window.location.search || '');
          // Сохраняем фрагмент: в нём Telegram передаёт initData, и полная перезагрузка
          // без него приводила к экрану «Не удалось получить данные авторизации».
          window.location.replace(path + (window.location.hash || ''));
        }
        return Promise.reject(error);
      },
    );
  }

  get client() {
    return this.api;
  }

  setToken(token: string) {
    localStorage.setItem('accessToken', token);
  }

  removeToken() {
    localStorage.removeItem('accessToken');
  }
}

export const apiService = new ApiService();

